import React from 'react';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
import { Select } from '../components/ui/Select';
export function EditProfileCustomFields() {
  return <div className="space-y-6 max-w-2xl mx-auto" data-id="element-252">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-253">
        Edit My Profile Custom Fields:
      </h1>

      <Card data-id="element-254">
        <CardContent className="space-y-6 pt-6" data-id="element-255">
          <Select label="Select Field" options={[{
          value: '1',
          label: 'Field 1'
        }, {
          value: '2',
          label: 'Field 2'
        }, {
          value: '3',
          label: 'Field 3'
        }]} data-id="element-256" />

          <div className="space-y-2" data-id="element-257">
            <label className="block text-sm font-medium text-slate-700" data-id="element-258">
              Select Field Type
            </label>
            <div className="flex items-center gap-6" data-id="element-259">
              <label className="flex items-center gap-2" data-id="element-260">
                <input type="radio" name="fieldType" value="text" defaultChecked className="text-slate-900 focus:ring-slate-900" data-id="element-261" />
                <span className="text-sm text-slate-700" data-id="element-262">Text Field</span>
              </label>
              <label className="flex items-center gap-2" data-id="element-263">
                <input type="radio" name="fieldType" value="dropdown" className="text-slate-900 focus:ring-slate-900" data-id="element-264" />
                <span className="text-sm text-slate-700" data-id="element-265">Drop Down</span>
              </label>
            </div>
          </div>

          <Input label="Field label text input" defaultValue="are you on facebook?" data-id="element-266" />

          <div className="flex items-center gap-2" data-id="element-267">
            <input type="checkbox" id="required" className="rounded border-slate-300 text-slate-900 focus:ring-slate-900" data-id="element-268" />
            <label htmlFor="required" className="text-sm font-medium text-slate-700" data-id="element-269">
              Required
            </label>
          </div>

          <div className="pt-4" data-id="element-270">
            <Button data-id="element-271">Submit</Button>
          </div>
        </CardContent>
      </Card>
    </div>;
}